import apiClient from '../shared/lib/apiClient';

// Kept for existing callers. Returns the shared apiClient so every request gets the
// same token refresh and 401 handling (see docs/spec/auth-lifecycle.md).
export function useApi() {
  return apiClient;
}
